import axios from 'axios'

export default {
  namespaced: true,
  state: {
    open: 0,
    items: [],
    item: {},
    info: {},
    estrattoContoAnalitico: {},
    totaliEstrattoContoAnalitico: {},
    estrattoContoPerAnno: {},
    totaliEstrattoContoPerAnno: {},
    dettaglioDocumentoById: [],
    dettaglioPagato: {},
    dettaglioRateEmesse: {},
    visualizzaVersamenti: {},
    dettaglioVersamenti: {},
    estrattoContoPerAnnoXls: {},
    matricoleFiltrate: {},
  },

  mutations: {
    setOpen(state, value) {
      state.open = value || 0
    },
    setItems(state, value) {
      state.items = value || []
    },
    setItem(state, value) {
      state.item = value || {}
    },
    setInfo(state, value) {
      state.info = value || {}
    },
    setEstrattoContoAnalitico(state, value) {
      state.estrattoContoAnalitico = value || {}
    },
    setTotaliEstrattoContoAnalitico(state, value) {
      state.totaliEstrattoContoAnalitico = value || {}
    },
    setEstrattoContoPerAnno(state, value) {
      state.estrattoContoPerAnno = value || {}
    },
    setTotaliEstrattoContoPerAnno(state, value) {
      state.totaliEstrattoContoPerAnno = value || {}
    },
    setDettaglioDocumentoById(state, value) {
      state.dettaglioDocumentoById = value || []
    },
    setDettaglioPagato(state, value) {
      state.dettaglioPagato = value || {}
    },
    setDettaglioRateEmesse(state, value) {
      state.dettaglioRateEmesse = value || {}
    },
    setVisualizzaVersamenti(state, value) {
      state.visualizzaVersamenti = value || {}
    },
    setDettaglioVersamenti(state, value) {
      state.dettaglioVersamenti = value || {}
    },
    setEstrattoContoPerAnnoXls(state, value) {
      state.estrattoContoPerAnnoXls = value || {}
    },
  },

  actions: {
    async loadItems({ commit }) {
      try {
        // console.log('Elenco estratti conto')
        let rs = await axios.get('/api/estratticonto')
        commit('setItems', rs.data)
      } catch (err) {
        throw err
      }
    },
    async loadItemById({ commit }, id) {
      try {
        let rs = await axios.get(`/api/estratticonto/${id}`)
        commit('setItem', rs.data)
      } catch (err) {
        throw err
      }
    },
    async countOpen({ commit }) {
      try {
        let rs = await axios.get('/api/estratticonto', { params: { op: 'contaAperte' } })
        commit('setOpen', rs.data.count)
      } catch (err) {
        throw err
      }
    },


    async info({ commit }) {
      try {
        let rs = await axios.post('/api/estratticonto/info')
        commit('setInfo', rs.data)
      } catch (err) {
        throw err
      }
    },
    async estrattoContoAnalitico({ commit }, parameters) {
      try {
        let rs = await axios.post('/api/estratticonto/estratto_conto_analitico', { params: parameters })
        commit('setEstrattoContoAnalitico', rs.data)
      } catch (err) {
        throw err
      }
    },
    async totaliEstrattoContoAnalitico({ commit }, parameters) {
      try {
        let rs = await axios.post('/api/estratticonto/estratto_conto_analitico/totali', { params: parameters })
        commit('setTotaliEstrattoContoAnalitico', rs.data)
      } catch (err) {
        throw err
      }
    },
    async estrattoContoPerAnno({ commit }, parameters) {
      try {
        let rs = await axios.post('/api/estratticonto/estratto_conto_per_anno', { parameters })
        commit('setEstrattoContoPerAnno', rs.data)
      } catch (err) {
        throw err
      }
    },
    async totaliEstrattoContoPerAnno({ commit }, parameters) {
      try {
        let rs = await axios.post('/api/estratticonto/estratto_conto_per_anno/totali', { parameters })
        commit('setTotaliEstrattoContoPerAnno', rs.data)
      } catch (err) {
        throw err
      }
    },
    async dettaglioDocumentoById({ commit }, parameters) {
      try {
        let rs = await axios.get(`/api/estratticonto/${parameters.id}/dettaglio_documento`, { params: { tipo: parameters.tipo, codiciRU: parameters.codiciRU, matricola: parameters.matricola } })
        commit('setDettaglioDocumentoById', rs.data)
      } catch (err) {
        throw err
      }
    },
    async dettaglioPagato({ commit }, parameters) {
      try {
        let rs = await axios.get(`/api/estratticonto/${parameters.id}/dettaglio_pagato`, { params: { codiciRU: parameters.codiciRU, matricola: parameters.matricola } })
        commit('setDettaglioPagato', rs.data)
      } catch (err) {
        throw err
      }
    },
    async dettaglioRateEmesse({ commit }, parameters) {
      try {
        let rs = await axios.get(`/api/estratticonto/${parameters.id}/dettaglio_rate_emesse`, { params: { codiciRU: parameters.codiciRU, matricola: parameters.matricola } })
        commit('setDettaglioRateEmesse', rs.data)
      } catch (err) {
        throw err
      }
    },
    async visualizzaVersamenti({ commit }, parameters) {
      try {
        let rs = await axios.post('/api/estratticonto/visualizza_versamenti', { params: parameters })
        commit('setVisualizzaVersamenti', rs.data)
      } catch (err) {
        throw err
      }
    },
    async getDettaglioVersamenti({ commit }, parameters) {
      try {
        let rs = await axios.get(`/api/estratticonto/${parameters.id}/dettaglio_versamenti`, { params: { codiciRU: parameters.codiciRU, matricola: parameters.matricola } })
        commit('setDettaglioVersamenti', rs.data)
      } catch (err) {
        throw err
      }
    },
    async estrattoContoPerAnnoXls({ commit }, parameters) {
      try {
        let rs = await axios.post('/api/estratticonto/estratto_conto_per_anno_xls', { parameters })
        commit('setEstrattoContoPerAnnoXls', rs.data)
      } catch (err) {
        throw err
      }
    }
  }
}
